'use strict'
module.exports = {
    videoPosterPrefix: 'addPanelData/sections/videos_en/gridGalleries/v1/gallery-video-thumb-grid-',
    videoSrcPrefix: 'v1/gallery-video-thumb-grid-'
}
